/* ============================================================
   HYDRO PLANT — Apple-style compare table builder
   Reads a JSON payload rendered by sections/page-product-compare.liquid
   and builds an interactive up-to-3-column comparison, locked per
   collection group. No dependencies.
   ============================================================ */
(function () {
  var ICONS = {
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 4 13c0-6 8-9 15-9 0 7-3 15-9 15-2 0-3.5-1-4-3"/><path d="M2 22c3-4 6-6 10-8"/></svg>',
    water: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.7S5 10 5 14.5A7 7 0 0 0 19 14.5C19 10 12 2.7 12 2.7z"/></svg>',
    timer: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5M9 2h6"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 7v3M10 7v5M14 7v3M18 7v5"/></svg>',
    wifi: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5a10 10 0 0 1 14 0M8 15.5a6 6 0 0 1 8 0"/><circle cx="12" cy="19" r="1"/></svg>',
    battery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="17" height="8" rx="2"/><path d="M22 11v2"/><path d="M5 11v2"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 3v6c0 5-3.5 8-8 11-4.5-3-8-6-8-11V5z"/><path d="M9 12l2 2 4-4"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>',
    temp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 14V4a2 2 0 1 1 4 0v10a4 4 0 1 1-4 0z"/></svg>',
    plant: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22V10"/><path d="M12 12C9 12 6 10 6 6c4 0 6 2 6 6zM12 10c0-4 2-6 6-6 0 4-3 6-6 6z"/><path d="M7 22h10"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
  };

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function CompareApple(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-hp-compare-data]');
    if (!dataEl) return;
    try { this.payload = JSON.parse(dataEl.textContent); }
    catch (e) { this.payload = { config: {}, groups: [] }; }
    this.config = this.payload.config || {};
    this.groups = this.payload.groups || [];
    this.maxCols = Math.max(2, Math.min(3, parseInt(this.config.maxColumns, 10) || 3));
    this.activeGroup = 0;
    this.selection = [];
    this.groupsWrap = root.querySelector('[data-hp-groups]');
    this.tableWrap = root.querySelector('[data-hp-table]');
    if (!this.groups.length) { this.renderEmpty(); return; }
    this.renderGroups();
    this.resetSelection();
    this.renderTable();
  }

  CompareApple.prototype.renderEmpty = function () {
    if (this.tableWrap) {
      this.tableWrap.innerHTML = '';
      this.tableWrap.appendChild(el('div', 'hp-compare__empty-msg',
        'No comparison groups are set up yet. Add a "Comparison group" block to this section in the theme editor and pick a collection.'));
    }
  };

  CompareApple.prototype.renderGroups = function () {
    if (!this.groupsWrap) return;
    this.groupsWrap.innerHTML = '';
    if (this.groups.length < 2) { this.groupsWrap.style.display = 'none'; return; }
    var self = this;
    this.groups.forEach(function (g, i) {
      var b = el('button', 'hp-compare__group-btn' + (i === self.activeGroup ? ' is-active' : ''), g.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        self.activeGroup = i;
        self.resetSelection();
        self.groupsWrap.querySelectorAll('.hp-compare__group-btn').forEach(function (x, xi) {
          x.classList.toggle('is-active', xi === i);
        });
        self.renderTable();
      });
      self.groupsWrap.appendChild(b);
    });
  };

  CompareApple.prototype.currentProducts = function () {
    var g = this.groups[this.activeGroup];
    return (g && g.products) || [];
  };

  CompareApple.prototype.resetSelection = function () {
    var prods = this.currentProducts();
    this.selection = [];
    for (var i = 0; i < this.maxCols; i++) {
      this.selection.push(prods[i] ? prods[i].handle : '');
    }
  };

  CompareApple.prototype.findProduct = function (handle) {
    if (!handle) return null;
    var prods = this.currentProducts();
    for (var i = 0; i < prods.length; i++) if (prods[i].handle === handle) return prods[i];
    return null;
  };

  CompareApple.prototype.gridTemplate = function () {
    return 'minmax(130px, 0.75fr) repeat(' + this.maxCols + ', minmax(var(--hpc-col-min), 1fr))';
  };

  CompareApple.prototype.renderTable = function () {
    var self = this;
    var wrap = this.tableWrap;
    if (!wrap) return;
    wrap.innerHTML = '';

    var scroll = el('div', 'hp-compare__scroll');
    var grid = el('div', 'hp-compare__grid');
    grid.style.gridTemplateColumns = this.gridTemplate();

    var selected = this.selection.map(function (h) { return self.findProduct(h); });

    /* ---- Header row: label spacer + picker cards ---- */
    grid.appendChild(el('div', 'hp-compare__header-cell', ''));
    this.selection.forEach(function (handle, col) {
      var cell = el('div', 'hp-compare__header-cell');
      cell.appendChild(self.buildPicker(handle, col));
      grid.appendChild(cell);
    });

    /* ---- Optional highlights row ---- */
    if (this.config.enableHighlights) {
      var anyHl = selected.some(function (p) { return p && p.highlights && p.highlights.length; });
      if (anyHl) {
        grid.appendChild(this.labelCell('Highlights'));
        selected.forEach(function (p) {
          var cell = el('div', 'hp-compare__value-cell');
          if (p && p.highlights && p.highlights.length) {
            var band = el('div', 'hp-compare__highlights');
            p.highlights.forEach(function (h) {
              var hl = el('div', 'hp-compare__hl');
              var ic = ICONS[(h.icon || '').toLowerCase()];
              if (ic) hl.appendChild(el('span', 'hp-compare__hl-icon', ic));
              hl.appendChild(el('span', 'hp-compare__hl-text', self.esc(h.text)));
              band.appendChild(hl);
            });
            cell.appendChild(band);
          } else {
            cell.appendChild(el('span', 'hp-compare__na', 'Not specified'));
          }
          grid.appendChild(cell);
        });
      }
    }

    /* ---- Build the ordered list of rows ---- */
    var rows = [];
    var c = this.config;
    if (c.showPrice) rows.push({ label: c.priceLabel || 'Price', key: '__price' });
    if (c.showAvailability) rows.push({ label: c.availabilityLabel || 'Availability', key: '__avail' });
    if (c.showType) rows.push({ label: 'Category', key: '__type' });
    if (c.showVendor) rows.push({ label: 'Brand', key: '__vendor' });

    // Union of spec labels across selected products, first-seen order
    var seen = {};
    selected.forEach(function (p) {
      if (!p || !p.specs) return;
      p.specs.forEach(function (s) {
        if (!seen[s.label]) { seen[s.label] = true; rows.push({ label: s.label, key: 'spec' }); }
      });
    });

    var zebra = false;
    rows.forEach(function (row) {
      var best = self.bestIndices(row, selected);
      var rowEls = [self.labelCell(row.label)];
      selected.forEach(function (p, ci) {
        var cell = self.valueCell(self.cellValue(p, row));
        if (best.indexOf(ci) !== -1) cell.classList.add('hp-compare__cell--best');
        rowEls.push(cell);
      });
      if (zebra) rowEls.forEach(function (e) { e.classList.add('hp-compare__row--zebra'); });
      zebra = !zebra;
      rowEls.forEach(function (e) { grid.appendChild(e); });
    });

    scroll.appendChild(grid);
    wrap.appendChild(scroll);

    /* ---- Closing CTA (fills the gap before the footer) ---- */
    var group = this.groups[this.activeGroup];
    if (group && group.url) {
      var cta = el('div', 'hp-compare__closing');
      var a = document.createElement('a');
      a.className = 'hp-compare__closing-btn';
      a.href = group.url;
      a.textContent = (this.config.closingLabel || 'Shop all ') + (group.label || '');
      cta.appendChild(a);
      wrap.appendChild(cta);
    }

    /* ---- Compact sticky bar (pins once the tall header scrolls off) ---- */
    this.buildStickyBar(selected);
  };

  CompareApple.prototype.buildStickyBar = function (selected) {
    var self = this;
    if (this.bar && this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
    var bar = el('div', 'hp-compare__sticky-bar');
    bar.appendChild(el('div', 'hp-compare__sbar-spacer'));
    selected.forEach(function (p) {
      var cell = el('div', 'hp-compare__sbar-cell');
      if (p) {
        var mini = el('div', 'hp-compare__sbar-mini');
        if (p.image) {
          var im = document.createElement('img');
          im.src = p.image; im.alt = p.title; im.className = 'hp-compare__sbar-img';
          mini.appendChild(im);
        }
        var txt = el('div', 'hp-compare__sbar-txt');
        txt.appendChild(el('span', 'hp-compare__sbar-name', self.esc(p.title)));
        txt.appendChild(el('span', 'hp-compare__sbar-price', p.price || ''));
        mini.appendChild(txt);
        var a = document.createElement('a');
        a.className = 'hp-compare__sbar-cta';
        a.href = p.url;
        a.textContent = self.config.ctaLabel || 'View';
        mini.appendChild(a);
        cell.appendChild(mini);
      }
      bar.appendChild(cell);
    });
    this.root.appendChild(bar);
    this.bar = bar;
    if (!this._barBound) {
      this._barBound = true;
      var onS = function () { self.positionBar(); };
      window.addEventListener('scroll', onS, { passive: true });
      window.addEventListener('resize', onS);
    }
    this.positionBar();
  };

  // Pin directly under the site's sticky header, following its reveal/hide.
  CompareApple.prototype.stickyTop = function () {
    var header = document.querySelector('.m-header__wrapper') || document.querySelector('.m-header');
    if (header) {
      var cs = getComputedStyle(header);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        return Math.max(0, header.getBoundingClientRect().bottom) + 6;
      }
    }
    return parseInt(getComputedStyle(this.root).getPropertyValue('--hpc-sticky-top'), 10) || 70;
  };

  CompareApple.prototype.positionBar = function () {
    var bar = this.bar;
    if (!bar) return;
    var gridEl = this.root.querySelector('.hp-compare__grid');
    var headerCell = this.root.querySelector('.hp-compare__header-cell');
    if (!gridEl || !headerCell || window.innerWidth < 768) { bar.classList.remove('is-visible'); return; }
    var top = this.stickyTop();
    var headerBottom = headerCell.getBoundingClientRect().bottom;
    var gridRect = gridEl.getBoundingClientRect();
    if (headerBottom <= top && gridRect.bottom > top + 60) {
      bar.style.left = gridRect.left + 'px';
      bar.style.width = gridRect.width + 'px';
      bar.style.top = top + 'px';
      bar.style.gridTemplateColumns = gridEl.style.gridTemplateColumns || this.gridTemplate();
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  };

  CompareApple.prototype.parseNum = function (s) {
    if (s == null) return null;
    var m = ('' + s).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  };

  CompareApple.prototype.rawFor = function (p, row) {
    if (!p) return { num: null, bool: null };
    if (row.key === '__price') return { num: this.parseNum(p.price), bool: null };
    if (row.key === '__avail') return { num: null, bool: !!p.available };
    if (row.key === '__type' || row.key === '__vendor') return { num: null, bool: null };
    var val = null;
    if (p.specs) {
      for (var i = 0; i < p.specs.length; i++) {
        if (p.specs[i].label === row.label) { val = p.specs[i].value; break; }
      }
    }
    if (val == null || val === '') return { num: null, bool: null };
    var low = ('' + val).trim().toLowerCase();
    if (low === '—' || low === '–' || low === '-' || low === 'n/a' || low === 'na' || low === 'none' || low === 'tbd') return { num: null, bool: null };
    if (low === 'yes' || low === 'true' || low === '✓') return { num: null, bool: true };
    if (low === 'no' || low === 'false' || low === '✗') return { num: null, bool: false };
    return { num: this.parseNum(val), bool: null };
  };

  // Which column(s) hold the "best" value in a row. Higher wins by default;
  // price / cost / weight / noise are treated as lower-is-better.
  CompareApple.prototype.bestIndices = function (row, selected) {
    if (this.config.highlightBest === false) return [];
    var self = this;
    var lowerBetter = row.key === '__price' || /price|cost|weight|noise/i.test(row.label);
    var nums = [], bools = [], anyNum = false, anyBool = false;
    selected.forEach(function (p, i) {
      var r = self.rawFor(p, row);
      nums[i] = r.num; bools[i] = r.bool;
      if (r.num != null) anyNum = true;
      if (r.bool != null) anyBool = true;
    });
    if (anyNum) {
      var valid = [];
      nums.forEach(function (n, i) { if (n != null) valid.push(i); });
      if (valid.length < 2) return [];
      var best = nums[valid[0]];
      valid.forEach(function (i) { best = lowerBetter ? Math.min(best, nums[i]) : Math.max(best, nums[i]); });
      var allEqual = valid.every(function (i) { return nums[i] === nums[valid[0]]; });
      if (allEqual) return [];
      return valid.filter(function (i) { return nums[i] === best; });
    }
    if (anyBool) {
      var trues = [], falses = 0;
      bools.forEach(function (b, i) { if (b === true) trues.push(i); else if (b === false) falses++; });
      if (trues.length >= 1 && falses >= 1) return trues;
      return [];
    }
    return [];
  };

  CompareApple.prototype.cellValue = function (p, row) {
    var NA = '<span class="hp-compare__na">Not specified</span>';
    if (!p) return NA;
    if (row.key === '__price') {
      if (p.compareAtPrice) return '<span class="hp-compare__pprice"><s>' + p.compareAtPrice + '</s>' + p.price + '</span>';
      return p.price || NA;
    }
    if (row.key === '__avail') {
      return p.available
        ? '<span class="hp-compare__yes">In stock</span>'
        : '<span class="hp-compare__no">Sold out</span>';
    }
    if (row.key === '__type') return this.esc(p.type) || NA;
    if (row.key === '__vendor') return this.esc(p.vendor) || NA;
    // spec
    var val = null;
    if (p.specs) {
      for (var i = 0; i < p.specs.length; i++) {
        if (p.specs[i].label === row.label) { val = p.specs[i].value; break; }
      }
    }
    if (val == null || val === '') return NA;
    var low = ('' + val).trim().toLowerCase();
    if (low === '—' || low === '–' || low === '-' || low === 'n/a' || low === 'na' || low === 'none' || low === 'tbd') return NA;
    if (low === 'yes' || low === 'true' || low === '✓') return '<span class="hp-compare__yes">' + ICONS.check + '</span>';
    if (low === 'no' || low === 'false' || low === '✗') return '<span class="hp-compare__no">No</span>';
    return this.esc(val);
  };

  CompareApple.prototype.labelCell = function (text) {
    return el('div', 'hp-compare__label-cell', this.esc(text));
  };
  CompareApple.prototype.valueCell = function (html) {
    return el('div', 'hp-compare__value-cell', html);
  };

  CompareApple.prototype.buildPicker = function (handle, col) {
    var self = this;
    var p = this.findProduct(handle);
    var box = el('div', 'hp-compare__picker');

    // thumbnail
    var thumb = el('div', 'hp-compare__thumb');
    if (p && p.image) {
      var img = document.createElement('img');
      img.src = p.image; img.alt = p.title; img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      thumb.classList.add('hp-compare__thumb--empty');
      thumb.textContent = 'Choose a product';
    }
    box.appendChild(thumb);

    // select dropdown
    var selWrap = el('div', 'hp-compare__select-wrap');
    var sel = document.createElement('select');
    sel.className = 'hp-compare__select';
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = 'Select a product';
    sel.appendChild(ph);
    this.currentProducts().forEach(function (prod) {
      var o = document.createElement('option');
      o.value = prod.handle; o.textContent = prod.title;
      if (prod.handle === handle) o.selected = true;
      // prevent duplicate selection across columns
      if (prod.handle !== handle && self.selection.indexOf(prod.handle) !== -1) o.disabled = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      self.selection[col] = sel.value;
      self.renderTable();
    });
    selWrap.appendChild(sel);
    box.appendChild(selWrap);

    // name + price + cta
    box.appendChild(el('div', 'hp-compare__pname', p ? this.esc(p.title) : '&nbsp;'));
    if (this.config.showHeaderPrice !== false) {
      var priceHtml = '&nbsp;';
      if (p) priceHtml = (p.compareAtPrice ? '<s>' + p.compareAtPrice + '</s>' : '') + (p.price || '');
      box.appendChild(el('div', 'hp-compare__pprice', priceHtml));
    }
    if (p) {
      if (this.config.ctaAction === 'add' && p.variantId) {
        var addBtn = el('button', 'hp-compare__cta' + (this.config.ctaClass ? ' ' + this.config.ctaClass : ''), this.esc(this.config.ctaLabel || 'Add to cart'));
        addBtn.type = 'button';
        addBtn.addEventListener('click', function () { self.addToCart(p.variantId, addBtn); });
        box.appendChild(addBtn);
      } else {
        var link = document.createElement('a');
        link.className = 'hp-compare__cta' + (this.config.ctaClass ? ' ' + this.config.ctaClass : '');
        link.href = p.url;
        link.textContent = this.config.ctaLabel || 'View product';
        box.appendChild(link);
      }
      var clear = el('button', 'hp-compare__clear', 'Remove');
      clear.type = 'button';
      clear.addEventListener('click', function () { self.selection[col] = ''; self.renderTable(); });
      box.appendChild(clear);
    }
    return box;
  };

  CompareApple.prototype.addToCart = function (variantId, btn) {
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.textContent = original; });
  };

  CompareApple.prototype.esc = function (s) {
    if (s == null) return '';
    return ('' + s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  function init() {
    document.querySelectorAll('[data-hp-compare]').forEach(function (root) {
      if (root.__hpCompareInit) return;
      root.__hpCompareInit = true;
      new CompareApple(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
